import styled, { CSSProperties } from 'styled-components';

export const LoadingSpinner = (props: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <SpinnerWrapper width={props.width} style={props.style}>
      <Spinner1 width={props.width} />
      <Spinner2 width={props.width} />
    </SpinnerWrapper>
  );
};

const SpinnerWrapper = styled.div<{ width: number }>`
  margin-left: auto;
  margin-right: auto;
  width: ${(props) => props.width + 'px'};
  height: ${(props) => props.width + 'px'};
`;

const Spinner1 = styled.div<{ width: number }>`
  @keyframes spin {
    from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
  }
  animation-name: spin;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  position: relative;

  width: ${(props) => props.width + 'px'};
  height: ${(props) => props.width + 'px'};

  border: 3px solid rgba(0, 0, 0, 0.5);
`;

const Spinner2 = styled.div<{ width: number }>`
  @keyframes spin2 {
    from {
      transform: rotate(0.25turn);
    }
    to {
      transform: rotate(0.75turn);
    }
  }
  animation-name: spin2;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  position: relative;
  top: ${(props) => '-' + props.width + 'px'};

  margin-left: auto;
  margin-right: auto;

  width: ${(props) => props.width + 'px'};
  height: ${(props) => props.width + 'px'};

  border: 3px solid rgba(0, 0, 0, 0.5);
`;
